import * as React from 'react';
import classnames from 'classnames';

export function DropdownFacet(props) {
  const {label, options, onChange: setFilter, initialFacetValues = [], isFirstFacet = false} = props;

  // Auto-cascade for subsequent facets: if the current selection has count=0,
  // replace it with the first valid option in a single state update.
  React.useEffect(() => {
    if (isFirstFacet) return;

    const selected = options.find(o => o.selected);
    if (selected && selected.count > 0) return;

    const firstValid = options.find(o => o.count > 0);
    if (firstValid) setFilter(firstValid.value);
  }, [options, isFirstFacet]);

  const merged = React.useMemo(() => {
    const existing = new Map(options.map(o => [o.value, o]));
    const missing = initialFacetValues
      .filter(v => !existing.has(v))
      .map(v => ({value: v, count: 0, selected: false}));
    return [...options, ...missing].sort((a, b) => String(a.value).localeCompare(String(b.value)));
  }, [options, initialFacetValues]);

  const selectedItem = merged.find(o => o.selected);

  const containerRef = React.useRef(null);

  const toggleDropdown = () => {
    containerRef.current.classList.toggle('group-selector--expanded');
  };

  const handleSelect = (value) => {
    if (selectedItem?.value === value) return;
    setFilter(value);
    toggleDropdown();
  };

  return (
    <div className="group-selector" ref={containerRef}>
      <div className="group-selector__selected">
        <button type="button" onClick={toggleDropdown}>
          {selectedItem?.value || 'Select...'}
          <div className="transition-transform rotate-0">
            <svg className="size-[24px]" fill="none" viewBox="0 0 24 24">
              <path d="M7 10l5 5 5-5" stroke="#666666" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round"/>
            </svg>
          </div>
        </button>
      </div>
      <div className="group-selector__items">
        {merged.map(option => {
          const disabled = !isFirstFacet && option.count === 0;
          return (
            <div
              key={option.value}
              className={classnames('group-selector__item', {
                'group-selector__item--selected': option.selected,
              })}
            >
              <button
                type="button"
                disabled={disabled}
                onClick={() => handleSelect(option.value)}
              >
                {option.value}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
